import { Injectable } from '@angular/core';
import { DocumentoDaoService } from 'src/app/dao/documento-dao-service';
import { ListenerAllPagesService } from 'src/app/listeners/listener-all-pages.service';
import { Documento, DocumentoLink } from 'src/app/models/documento.model';
import { DialogService } from 'src/app/services/dialog.service';
import { NavigateService } from 'src/app/services/navigate.service';
import { TemplateService } from '../templates/template.service';

@Injectable({
  providedIn: 'root'
})

export class DocumentoService {
  
  constructor(
    public dialog: DialogService,
    public templateService: TemplateService,
    public allPages: ListenerAllPagesService,
    public documentoDao: DocumentoDaoService,
    public go: NavigateService
  ) { }

  /*public selectRoute(especie: TemplateEspecie): FullRoute {
    return {route: ['uteis', 'templates'], params: {filter: {especie}}};
  }*/

  public preview(documentoOuId: any) {
    const documento = typeof documentoOuId == "string" ? undefined : documentoOuId as Documento;
    const documentoId = typeof documentoOuId == "string" ? documentoOuId : documento!.id;
    this.go.navigate({route: ['uteis', 'documentos' , 'preview', documentoId]}, {metadata: {documento, documentoId}});
    //this.dialog.html({ title: "Pre-visualização do documento", modalWidth: 1000 }, documento.conteudo!, []);
  }

  public onLinkClick(link: DocumentoLink) {
    if(link?.tipo == "SEI") {
      this.allPages.openDocumentoSei(link?.id_processo || 0, link?.id_documento || 0);
    } else if(link?.tipo == "URL") {
      this.go.openNewTab(link?.url || "#");
    }
  }

  public async onDocumentoClick(documento: Documento) {
    if(documento.tipo == "LINK" && documento.link) {
      this.onLinkClick(documento.link);
    } else if(documento.tipo == "HTML") {
      /* Caso o conteúdo do arquivo não venha junto com a requisição por questões de otimização, ele busca o conteúdo agora 
      if(!documento.conteudo) {
        try {
          this.dialog.showSppinerOverlay();
          let conteudo = await this.documentoDao.getById(documento.id);
          documento.conteudo = conteudo?.conteudo || "";
        } finally {
          this.dialog.closeSppinerOverlay();
        }
      } */
      this.preview(documento.id);
    }
  }

  public documentoHint(documento: Documento): string {
    return this.allPages.getButtonTitle(documento.link?.numero_processo, documento.link?.numero_documento);
  }

  public sign(documentos: Documento[]): Promise<Documento[] | undefined> {
    return new Promise<Documento[] | undefined>((resolve, reject) => {
      this.go.navigate({route: ["uteis", "documentos", "assinar"]}, {
        metadata: { documentos },
        modalClose: resolve
      });
    });
  }

}
